// Qué creaciones se ELIMINARON en esta sesión — ADR-2026-10-04-eliminar-saca-la-creacion-de-la-vista.
//
// El visor (`GeneratedImagesHistory`) borra el archivo y apaga la fila, pero quien lo abrió
// prestado —la cuadrícula de resultados, el lienzo del Agente, el modo Redes— no se
// enteraba: la creación seguía dibujada (en el lienzo, como un recuadro gris, porque el
// archivo ya no está). Acá queda la lista de ids borrados y un aviso para que cada vista
// los saque. Es memoria de la sesión: lo que ya estaba borrado al recargar lo dice la fila
// (`active = false`).

import { useEffect, useState } from 'react';

const EVENTO = 'atlas:creacion-eliminada';
const eliminadas = new Set<string>();

/** Lo llama quien borra, cuando la base ya confirmó. */
export function avisarCreacionEliminada(id: string | number): void {
  const clave = String(id);
  if (eliminadas.has(clave)) return;
  eliminadas.add(clave);
  try {
    window.dispatchEvent(new CustomEvent(EVENTO, { detail: { id: clave } }));
  } catch {
    /* sin window (tests): la lista igual quedó al día */
  }
}

/** Los ids borrados en esta sesión; el componente se vuelve a dibujar cuando se suma uno. */
export function useCreacionesEliminadas(): ReadonlySet<string> {
  const [foto, setFoto] = useState<ReadonlySet<string>>(() => new Set(eliminadas));
  useEffect(() => {
    const alBorrar = () => setFoto(new Set(eliminadas));
    // Por si se borró algo entre el primer render y este efecto.
    if (eliminadas.size !== foto.size) alBorrar();
    window.addEventListener(EVENTO, alBorrar);
    return () => window.removeEventListener(EVENTO, alBorrar);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return foto;
}
